import CreatableSelect from "react-select/creatable";
import Title from "common/Title";
import Select, { StylesConfig } from "react-select";

// icons
import { BiCategoryAlt } from "react-icons/bi";
import { BsFillFilePlusFill } from "react-icons/bs";
import { GoTrashcan } from "react-icons/go";
import { GiSave } from "react-icons/gi";

import "../components/HashtagManagement/hashtagmanagement.scss";

import Accordion from "react-bootstrap/Accordion";
import Form from "react-bootstrap/Form";

import { useState, useEffect } from "react";
import sendRequest from "hooks/useAxios";
import { sendRequestAPI2 } from "hooks/useAxios";
import { sendRequestHashtags } from "hooks/useAxios";
import { translateToReactSelect } from "utils/helperFunctions";
import Loader from "utils/Loader";
import { toast } from "react-hot-toast";
import Swal from "sweetalert2";
import logo from "assets/images/sitelogo.svg";
import ReactTooltip from "react-tooltip";
import { Helmet } from "react-helmet";
import toastFunction from "utils/toast";
export default function HashtagManagement({ logo }) {
  const [hashtagsListOption, setHashtagsListOption] = useState([]);
  const [subHashtagOption, setSubHashtagOption] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hashtagUpdater, setHashtagUpdater] = useState(false);
  const [displayStatus, setDisplayStatus] = useState("d-none");
  const [displayStatus2, setDisplayStatus2] = useState("d-none");
  const [selectedItem, setSelectedItem] = useState({});

  const [guildManager, setGuildManager] = useState([]);
  const [hashtag, setHashtag] = useState({ productGroup: "", guildAdmin: "" });
  const [newUser, setNewUser] = useState({ fname: "", lname: "", mobile: "" });
  console.log("hashtag", hashtag);
  const changeHandler = (value, type) => {
    setHashtag((prev) => {
      return { ...prev, [type]: value };
    });
  };
  // useEffect(() => {
  //   setHashtag({
  //     ...selectedItem,

  //     guildAdmin: selectedItem.admin_uid,
  //     productGroup: selectedItem.txt,
  //     hashtagId: selectedItem.id,
  //   });
  // }, [selectedItem]);
  console.log("selec", selectedItem);
  console.log("gu", guildManager);
  // const addHashtag = (object) => {
  //   sendRequest("Insert_hashtags", { txt: `${object}` }).then((data) => {
  //     if (data.data.status == true) {
  //       setHashtagUpdater((prev) => !prev);
  //       setHashtag("");
  //       toastFunction("success", "گروه کالایی با موفقیت ثبت شد.");
  //     }
  //   });
  // };
  const ClrarInput = () => {
    setHashtag({ productGroup: "", guildAdmin: "" });
  };
  const addHashtag = (object) => {
    let fd = new FormData();
    fd.append("txt", hashtag.productGroup);
    // fd.append("txt", `${object}`);
    if (hashtag.guildAdmin.value == "create") {
      fd.append("fname", newUser.fname);
      fd.append("lname", newUser.lname);
      fd.append("mobile", newUser.mobile);
    } else {
      fd.append("admin_uid", hashtag.guildAdmin.value);
    }
    sendRequestHashtags("add_hashtag", fd).then((data) => {
      if (data.data.status == true) {
        setHashtagUpdater((prev) => !prev);
        setHashtag("");
        // ClrarInput();
        toastFunction("success", "گروه کالایی با موفقیت ثبت شد.");
      }
    });
  };
  // const addSubHashtag = (hashtagid, subhashtags) => {
  //   let temp = [];
  //   let string = "";

  //   async function add() {
  //     for (let i = 0; i < subhashtags.length; i++) {
  //       if (subhashtags[i].__isNew__ == true) {
  //         let id = "";
  //         await sendRequest("Insert_hashtags", {
  //           txt: subhashtags[i].label,
  //         }).then((data) => {
  //           id = data.data.result.id;
  //         });

  //         temp.push(id);
  //       } else if (subhashtags[i].__isNew__ != true) {
  //         temp.push(subhashtags[i].value);
  //       }
  //     }
  //     string = temp.toString();
  //     // let fd = new FormData();
  //     // fd.append("txt", hashtag.productGroup);
  //     // fd.append("hashtag", hashtag);
  //     // fd.append("subhashtags", string);

  //     // if (hashtag.guildAdmin.value == "create") {
  //     //   fd.append("fname", newUser.fname);
  //     //   fd.append("lname", newUser.lname);
  //     //   fd.append("mobile", newUser.mobile);
  //     // } else {
  //     //   fd.append("admin_uid", hashtag.guildAdmin.value);
  //     // }
  //     let adminUid = {
  //       hashtag: hashtagid,
  //       subhashtags: string,
  //       txt: hashtag.productGroup,
  //     };

  //     if (hashtag.guildAdmin.value == "create") {
  //       adminUid = {
  //         ...adminUid,
  //         fname: newUser.fname,
  //         lname: newUser.lname,
  //         mobile: newUser.mobile,
  //       };
  //     } else {
  //       adminUid = { ...adminUid, admin_uid: hashtag.guildAdmin.value };
  //     }
  //     sendRequestHashtags("linkhashtags", adminUid)
  //       // sendRequestHashtags("linkhashtags", fd)
  //       .then((data) => {
  //         if (data.data.status == 1) {
  //           toastFunction("success", " زیر گروه کالایی با موفقیت تغییر کرد.");

  //           setHashtagUpdater((prev) => !prev);
  //         } else {
  //           toastFunction(
  //             "error",
  //             " متاسفانه مشکلی در ثبت زیر گروه کالایی پیش آمده است."
  //           );
  //         }
  //       });
  //   }
  //   add();
  // };
  console.log("hastah", hashtag);
  const deleteHashtag = (id) => {
    sendRequest("Update_hashtags", {
      conditions: `id/=/${id}`,
      keyvalues: `hashtag_status,1`,
    }).then((data) => {
      if (data.data.status == 1) {
        toastFunction("success", "گروه کالایی با موفقیت حذف شد.");

        setHashtagUpdater((prev) => !prev);
      } else {
        toastFunction(
          "error",
          " متاسفانه در ثبت گروه کالایی مشکلی به وجود آمده است."
        );
      }
    });
  };

  const subHashtagsHandler = (value, index) => {
    let temp = [...hashtagsListOption];
    temp[index].subs = value;
    setHashtagsListOption(temp);
  };
  const newUserHandler = (value, index) => {
    let temp = [...hashtagsListOption];
    temp[index].subs = value;
    setHashtagsListOption(temp);
  };

  // function subtractArrays(array1, array2) {
  //   return array1.filter((object1) => {
  //     return array2.find((object2) => {
  //       return object2.value == object1.value;
  //     });
  //   });
  // }
  const translateUserToReactSelect = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        if (arrayValue[index].id) {
          // obj.id = arrayValue[index].id;
        } else {
          // obj.title = arrayValue[index].label;
          // obj.id = arrayValue[index].value;
        }

        after.push(obj.id);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.label = `${arrayValue[index].fname} ${arrayValue[index].lname}${arrayValue[index].mobile}`;
        obj.value = arrayValue[index].id;
        obj.mobile = arrayValue[index].mobile;

        after.push(obj);
      }
    }

    return after;
  };

  useEffect(() => {
    // sendRequestHashtags("get_sub_hashtag");
    // sendRequestHashtags("get_main_hashtag");
    setIsLoading(true);
    async function tagsList() {
      let arrayOption = [];
      await sendRequestHashtags("get_sub_hashtag").then((data) => {
        let temp = [...data.data.data];
        let array = [];
        let object = {};
        for (let i = 0; i < temp.length; i++) {
          object = {
            label: temp[i].txt,
            value: temp[i].id,
          };
          array.push(object);
        }
        setSubHashtagOption(array);
      });
      await sendRequest("Find_users", { conditions: "type/in/1,3" }).then(
        ({ data }) => {
          const lists = translateUserToReactSelect(data, false);
          console.log("list", lists);
          console.log("data", data);

          setGuildManager((prev) => {
            return [
              { value: "create", label: "کاربر جدید" },
              ...prev,
              ...lists,
            ];
          });
        }
      );
      await sendRequestHashtags("get_main_hashtag").then((data) => {
        let temp =
          data?.data?.data?.length > 0 ? [...data?.data?.data?.reverse()] : [];

        for (let i = 0; i < temp.length; i++) {
          let subsArray = [];

          for (let j = 0; j < temp[i].subs.length; j++) {
            let object = {};
            object = {
              label: temp[i].subs[j].txt,
              value: temp[i].subs[j].id,
            };
            subsArray.push(object);
          }
          temp[i].subs = [...subsArray];
        }

        setHashtagsListOption(
          temp.filter((t) => t.hashtag.hashtag_status != 1)
        );
      });
      setIsLoading(false);
    }
    tagsList();
  }, [hashtagUpdater]);
  useEffect(() => ReactTooltip.rebuild());

  // console.log("hashtagsListOption", hashtagsListOption);
  // console.log("hashtagsList", hashtagsList);
  // console.log("subHashtagOption", subHashtagOption);

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`مدیریت گروه کالایی`} </title>
        {/* <link rel="shortcut icon" href={`${logo}`} /> */}
      </Helmet>
      {isLoading && <Loader />}
      <Title
        color="rgb(244 124 96)"
        title="مدیریت گروه کالایی"
        icon={BiCategoryAlt}
      />
      <div className="container hashtag-management">
        {/* add hashtag */}
        <Accordion className="col-12  mx-auto">
          <Accordion.Item eventKey="0">
            <Accordion.Header>ایجاد گروه کالایی جدید</Accordion.Header>
            <Accordion.Body>
              <Form.Group>
                <div className="d-flex justiy-content-between productGroup">
                  <div className="d-flex align-items-center  input-labale">
                    <Form.Label className="" style={{ whiteSpace: "nowrap" }}>
                      {" "}
                      گروه کالایی:
                    </Form.Label>

                    <Form.Control
                      className="form-control"
                      type="text"
                      value={hashtag.productGroup}
                      // onChange={(e) => setHashtag(e.target.value)}
                      onChange={(e) => {
                        setHashtag((prev) => {
                          return { ...prev, productGroup: e.target.value };
                        });
                      }}
                    />
                  </div>
                  <div className="d-flex align-items-center  input-labale ">
                    <Form.Label className="" style={{ whiteSpace: "nowrap" }}>
                      مدیر رسته :
                    </Form.Label>

                    <Select
                      className="w-100"
                      options={guildManager}
                      value={hashtag.guildAdmin}
                      onChange={(value) => {
                        changeHandler(value, "guildAdmin");
                        if (value.value == "create") {
                          setDisplayStatus("d-block");
                        } else {
                          setDisplayStatus("d-none");
                        }
                      }}
                    />
                  </div>
                  <div className="btn-add d-flex justify-content-center">
                    <BsFillFilePlusFill
                      className="ms-1"
                      data-tip="افزودن گروه کالایی"
                      data-for="gm-tooltip"
                      color="#398639"
                      style={{ width: 30, height: 30, cursor: "pointer" }}
                      onClick={(e) => {
                        addHashtag();
                        // addHashtag(hashtag);
                      }}
                    />
                  </div>
                </div>

                {/* ایجاد کاربر جدید */}
                <div className={`row d-flex  ${displayStatus} `}>
                  <div className="d-flex justiy-content-between p-NewUser mt-4">
                    <div className="d-flex align-items-center  newUser">
                      <Form.Label
                        className="lb-newUser"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        نام
                      </Form.Label>

                      <Form.Control
                        className="form-control inp-newUser"
                        type="text"
                        value={newUser.fname}
                        onChange={(e) => {
                          setNewUser((prev) => {
                            return { ...prev, fname: e.target.value };
                          });
                        }}
                      />
                    </div>
                    <div className="d-flex align-items-center  newUser ">
                      <Form.Label
                        className="lb-newUser"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        فامیل
                      </Form.Label>

                      <Form.Control
                        className="form-control inp-newUser"
                        type="text"
                        value={newUser.lname}
                        onChange={(e) =>
                          setNewUser((prev) => {
                            return { ...prev, lname: e.target.value };
                          })
                        }
                      />
                    </div>
                    <div className="d-flex align-items-center  newUser ">
                      <Form.Label
                        className="lb-newUser"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        موبایل
                      </Form.Label>

                      <Form.Control
                        className="form-control inp-newUser"
                        type="text"
                        value={newUser.mobile}
                        onChange={(e) =>
                          setNewUser((prev) => {
                            return { ...prev, mobile: e.target.value };
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
              </Form.Group>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <h5 className="text-center mt-3 mb-2">لیست گروههای کالایی</h5>
        {/* list hashtag */}
        <ListGrouos
          hashtagsListOption={hashtagsListOption}
          setHashtagsListOption={setHashtagsListOption}
          subHashtagOption={subHashtagOption}
          setSubHashtagOption={setSubHashtagOption}
          guildManager={guildManager}
          setGuildManager={setGuildManager}
          hashtagUpdater={hashtagUpdater}
          setHashtagUpdater={setHashtagUpdater}
        ></ListGrouos>
      </div>
    </div>
  );
}
export function ListGrouos({
  hashtagsListOption,
  setHashtagsListOption,
  subHashtagOption,
  setSubHashtagOption,
  guildManager,
  setGuildManager,
  hashtagUpdater,
  setHashtagUpdater,
}) {
  // const [hashtagUpdater, setHashtagUpdater] = useState(false);
  // const [displayStatus2, setDisplayStatus2] = useState("d-none");
  console.log("hashtagsListOption", hashtagsListOption);
  // console.log("guildManager", guildManager);

  const [hashtag2, setHashtag2] = useState({
    productGroup: "",
    guildAdmin: "",
  });
  const [newUser2, setNewUser2] = useState({
    fname: "",
    lname: "",
    mobile: "",
  });
  console.log("hashtag2", hashtag2);
  const changeHandler = (value, type) => {
    setHashtag2((prev) => {
      return { ...prev, [type]: value };
    });
  };
  const deleteHashtag = (id) => {
    sendRequest("Update_hashtags", {
      conditions: `id/=/${id}`,
      keyvalues: `hashtag_status,1`,
    }).then((data) => {
      if (data.data.status == 1) {
        toastFunction("success", "گروه کالایی با موفقیت حذف شد.");

        setHashtagUpdater((prev) => !prev);
      } else {
        toastFunction(
          "error",
          " متاسفانه در ثبت گروه کالایی مشکلی به وجود آمده است."
        );
      }
    });
  };
  const addSubHashtag = (hashtagid, subhashtags, adminGroup, nameGroup) => {
    let temp = [];
    let string = "";

    async function add() {
      for (let i = 0; i < subhashtags.length; i++) {
        if (subhashtags[i].__isNew__ == true) {
          let id = "";
          await sendRequest("Insert_hashtags", {
            txt: subhashtags[i].label,
          }).then((data) => {
            id = data.data.result.id;
          });

          temp.push(id);
        } else if (subhashtags[i].__isNew__ != true) {
          temp.push(subhashtags[i].value);
        }
      }
      string = temp.toString();

      let adminUid = {
        hashtag: hashtagid,
        subhashtags: string,
        // txt: hashtag2.productGroup,
        txt: nameGroup,
      };

      if (hashtag2.guildAdmin.value == "create") {
        adminUid = {
          ...adminUid,
          fname: newUser2.fnam,
          lname: newUser2.lname,
          mobile: newUser2.mobile,
        };
      } else {
        adminUid = { ...adminUid, admin_uid: adminGroup };
      }
      sendRequestHashtags("linkhashtags", adminUid).then((data) => {
        if (data.data.status == 1) {
          toastFunction("success", " زیر گروه کالایی با موفقیت تغییر کرد.");

          setHashtagUpdater((prev) => !prev);
        } else {
          toastFunction(
            "error",
            " متاسفانه مشکلی در ثبت زیر گروه کالایی پیش آمده است."
          );
        }
      });
    }
    add();
  };
  console.log("hashtag2", hashtag2);
  const subHashtagsHandler = (value, index) => {
    let temp = [...hashtagsListOption];
    temp[index].subs = value;
    setHashtagsListOption(temp);
  };
  const HashtagsHandler = (value, index, type) => {
    let temp = [...hashtagsListOption];
    temp[index].hashtag[type] = value;
    setHashtagsListOption(temp);
  };

  return (
    <ul className="mt-4" style={{ listStyle: "none" }}>
      {" "}
      {hashtagsListOption.map((value, index) => {
        return (
          <>
            <ListGrouosItems
              value={value}
              index={index}
              hashtag2={hashtag2}
              setHashtag2={setHashtag2}
              guildManager={guildManager}
              setGuildManager={setGuildManager}
              deleteHashtag={deleteHashtag}
              addSubHashtag={addSubHashtag}
              subHashtagsHandler={subHashtagsHandler}
              HashtagsHandler={HashtagsHandler}
              newUser2={newUser2}
              setNewUser2={setNewUser2}
              changeHandler={changeHandler}
              subHashtagOption={subHashtagOption}
            ></ListGrouosItems>
          </>
        );
      })}
    </ul>
  );
}
export function ListGrouosItems({
  value,
  index,
  hashtag2,
  setHashtag2,
  guildManager,
  setGuildManager,
  deleteHashtag,
  addSubHashtag,
  subHashtagsHandler,
  subHashtagOption,
  newUser2,
  setNewUser2,
  changeHandler,
  HashtagsHandler,
}) {
  const [displayStatus2, setDisplayStatus2] = useState("d-none");
  const [adminName, setAdminName] = useState(value.hashtag.txt);
  const [eachGroup, setEachGroup] = useState({
    name: value.hashtag.txt,
    admin_id: value.hashtag.admin_uid,
  });
  console.log("adminNAme", hashtag2, value);
  return (
    <>
      <li className="my-3">
        <Form.Group>
          <div className="d-flex flex-wrap justiy-content-between productGroup2">
            <div className="d-flex align-items-center  input-labale2">
              <div className="lb-inp2" style={{ whiteSpace: "nowrap" }}>
                <Form.Label className="" style={{ whiteSpace: "nowrap" }}>
                  {" "}
                  گروه کالایی
                </Form.Label>
              </div>

              <div className="select-inp2">
                <Form.Control
                  className="form-control"
                  type="text"
                  value={value.hashtag.txt}
                  onChange={(e) => {
                    HashtagsHandler(e.target.value, index, "txt");
                  }}
                />
              </div>
            </div>
            <div className="d-flex align-items-center  input-labale2 ">
              <div className="lb-inp2" style={{ whiteSpace: "nowrap" }}>
                <Form.Label className="" style={{ whiteSpace: "nowrap" }}>
                  مدیر رسته
                </Form.Label>
              </div>

              <div className="select-inp2">
                <Select
                  className="w-100"
                  options={guildManager}
                  value={guildManager.find(
                    (val) => val.value == value.hashtag.admin_uid
                  )}
                  onChange={(value) => {
                    HashtagsHandler(value.value, index, "admin_uid");

                    if (value.value == "create") {
                      setDisplayStatus2("d-block");
                    } else {
                      setDisplayStatus2("d-none");
                    }
                  }}
                />
              </div>
            </div>
          </div>

          {/* ایجاد کاربر جدید */}
          <div className={`row d-flex  ${displayStatus2} `}>
            <div className="d-flex justiy-content-between p-NewUser mt-4">
              <div className="d-flex align-items-center  newUser">
                <Form.Label
                  className="lb-newUser"
                  style={{ whiteSpace: "nowrap" }}
                >
                  نام
                </Form.Label>

                <Form.Control
                  className="form-control inp-newUser"
                  type="text"
                  value={newUser2.fname}
                  onChange={(e) => {
                    setNewUser2((prev) => {
                      return { ...prev, fname: e.target.value };
                    });
                  }}
                />
              </div>
              <div className="d-flex align-items-center  newUser ">
                <Form.Label
                  className="lb-newUser"
                  style={{ whiteSpace: "nowrap" }}
                >
                  فامیل
                </Form.Label>

                <Form.Control
                  className="form-control inp-newUser"
                  type="text"
                  value={newUser2.lname}
                  onChange={(e) =>
                    setNewUser2((prev) => {
                      return { ...prev, lname: e.target.value };
                    })
                  }
                />
              </div>
              <div className="d-flex align-items-center  newUser ">
                <Form.Label
                  className="lb-newUser"
                  style={{ whiteSpace: "nowrap" }}
                >
                  موبایل
                </Form.Label>

                <Form.Control
                  className="form-control inp-newUser"
                  type="text"
                  value={newUser2.mobile}
                  onChange={(e) =>
                    setNewUser2((prev) => {
                      return { ...prev, mobile: e.target.value };
                    })
                  }
                />
              </div>
            </div>
          </div>
        </Form.Group>
        <div className="d-flex flex-wrap align-items-center list mt-2 ">
          <div className="lb-subgroup" style={{ whiteSpace: "nowrap" }}>
            {" زیرگروه کالایی"}
          </div>
          <div className="select-subgroup">
            {" "}
            <CreatableSelect
              options={subHashtagOption}
              // options={subtractArrays(subHashtagOption, value.subs)}
              isMulti
              value={value.subs}
              className=""
              onChange={(e) => {
                subHashtagsHandler(e, index);
              }}
            />
          </div>
          <div className="box-btn">
            <GiSave
              className="ms-1 list-item"
              data-tip="ذخیره زیر گروه کالایی"
              data-for="gm-tooltip"
              color="#398639"
              style={{ width: 30, height: 30, cursor: "pointer" }}
              onClick={(e) => {
                Swal.fire({
                  title: "آیا از تغییرات اعمال شده مطمئن هستید؟",
                  showDenyButton: true,
                  confirmButtonColor: "rgb(25,135,84)",
                  confirmButtonText: "بله",
                  denyButtonText: `خیر`,
                }).then((result) => {
                  if (result.isConfirmed) {
                  }
                  addSubHashtag(
                    value.hashtag.id,
                    value.subs,
                    value.hashtag.admin_uid,
                    value.hashtag.txt
                  );
                });
              }}
            />
            <GoTrashcan
              className="ms-1 list-item"
              data-tip="حذف گروه کالایی"
              data-for="gm-tooltip"
              color="tomato"
              style={{ width: 30, height: 30, cursor: "pointer" }}
              onClick={() => {
                Swal.fire({
                  title: "آیا از حذف این گروه کالایی مطمئن هستید؟",
                  showDenyButton: true,
                  confirmButtonColor: "rgb(25,135,84)",
                  confirmButtonText: "بله",
                  denyButtonText: `خیر`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    deleteHashtag(value.hashtag.id);
                  }
                });
              }}
            />
          </div>
        </div>
      </li>
      <div className="LineSeparator"></div>
    </>
  );
}
